import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useFragment } from 'react-relay-offline'

import { useOccurrencesModal } from '../../hooks/useOccurrencesModal'
import { ModalContentTemplate } from '../../shared/types'
import { SalesAssociateMovementsTrackingModal } from '../SalesAssociateMovementsTrackingModal'
import { OccurrencesContentTemplate } from './OccurrencesContentTemplate'
import { MultipleAssistancesContentTemplate } from './MultipleAssistancesContentTemplate'
import type { OccurrencesModal_salesAssociate$key } from './__generated__/OccurrencesModal_salesAssociate.graphql'
import { SalesAssociatesContentTemplate } from './SalesAssociatesContentTemplate'

export const OccurrencesModalComponent = () => {
  const { isOpen, options, modalContentTemplate } = useOccurrencesModal()

  const salesAssociateData = useFragment<OccurrencesModal_salesAssociate$key>(
    graphql`
      fragment OccurrencesModal_salesAssociate on SalesAssociate {
        ...OccurrencesContentTemplate_salesAssociate
        ...MultipleAssistancesContentTemplate_salesAssociate
        ...SalesAssociatesContentTemplate_salesAssociate
      }
    `,
    options.salesAssociate
  )

  return (
    <SalesAssociateMovementsTrackingModal isOpen={isOpen}>
      <div>
        {modalContentTemplate === ModalContentTemplate.Occurrences && (
          <OccurrencesContentTemplate salesAssociateRef={salesAssociateData} />
        )}
        {modalContentTemplate === ModalContentTemplate.MultipleAssistances && (
          <MultipleAssistancesContentTemplate
            salesAssociateRef={salesAssociateData}
          />
        )}
        {modalContentTemplate === ModalContentTemplate.SalesAssociates && (
          <SalesAssociatesContentTemplate
            salesAssociateRef={salesAssociateData}
          />
        )}
      </div>
    </SalesAssociateMovementsTrackingModal>
  )
}

export const OccurrencesModal = () => {
  const { isOpen, options } = useOccurrencesModal()

  if (!isOpen || !options.occurrences.length) {
    return null
  }

  return <OccurrencesModalComponent />
}
